import { render } from "./FirRequestSubType.vue?vue&type=template&id=714c6a92"
import script from "./FirRequestSubType.vue?vue&type=script&lang=js"
export * from "./FirRequestSubType.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__